export enum DeclarationTypeEnum {
  FORFAITAIRE = "FORFAITAIRE", // Conventionnelle
  INDIVIDUELLE = "INDIVIDUELLE",
  DONNEE_PAR_DEFAUT = "DONNEE_PAR_DEFAUT",
  COLLECTIVE = "COLLECTIVE",
  EMPTY = "EMPTY",
  REUSE = "REUSE",
  UNKNOWN = "UNKNOWN",
  FICHE_CONFIGUREE = "FICHE_CONFIGUREE",
}

export function declarationTypeToLabel(declarationType: DeclarationTypeEnum): string {
  switch (declarationType) {
    case DeclarationTypeEnum.FORFAITAIRE:
      return "Forfaitaire"
    case DeclarationTypeEnum.INDIVIDUELLE:
      return "Individuelle"
    case DeclarationTypeEnum.DONNEE_PAR_DEFAUT:
      return "Donnée par défaut"
    case DeclarationTypeEnum.COLLECTIVE:
      return "Collective"
    case DeclarationTypeEnum.EMPTY:
      return "Vide"
    case DeclarationTypeEnum.REUSE:
      return "Ré-utilisé"
    case DeclarationTypeEnum.UNKNOWN:
      return "Inconnu"
    case DeclarationTypeEnum.FICHE_CONFIGUREE:
      return "Fiche configurée"
    default:
      return declarationType
  }
}
